import { render } from "./CorporateDashboard.vue?vue&type=template&id=726cf9b1&scoped=true"
import script from "./CorporateDashboard.vue?vue&type=script&lang=js"
export * from "./CorporateDashboard.vue?vue&type=script&lang=js"

import "./CorporateDashboard.vue?vue&type=style&index=0&id=726cf9b1&lang=css"
import "./CorporateDashboard.vue?vue&type=style&index=1&id=726cf9b1&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726cf9b1"]])

export default __exports__